<template>
	<v-dialog class="v-dialog-custom" :title="title" closable>
		<div class="message">{{message}}</div>
		<template slot="foot">
      <template v-for="(o,i) in buttons">
        <v-button :type="o.type" @click="callback(i)" :key="i">{{o.text}}</v-button>
        <span :key="i+0.1"> </span>
      </template>
		</template>
	</v-dialog>
</template>

<script>
import { isFunction } from "util";
export default {
  data() {
    return {
      title: "",
      message: "",
      buttons: [],
      callback: () => this.close()
    };
  },
  created(option, callback) {
    this.callback = i => {
      (isFunction(callback) && callback(i) == false) || this.close();
    };
    Object.assign(
      this,
      Object.assign(
        {
          title: "",
          message: "",
          buttons: [{ type: "primary", text: "确定" }, "取消"]
        },
        option,
        {
          buttons: (option.buttons || []).map(btn =>
            isString(btn) ? { text: btn } : btn
          )
        }
      )
    );
  }
};
</script>

<style lang="less">
.v-dialog-custom {
  > .body {
    > .message {
      padding: 20px;
      font-size: 16px;
    }
  }
}
</style>